exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.inline[data-v-242394c1] {\n  display: inline;\n}\n.toolbar4[data-v-242394c1] {\n  background: #2C397F;\n}\n\n", "", {"version":3,"sources":["/builds/tjro/stic/dsi/dides-adm/sesiex/chanceler/frontend/olimpia-front/src/components/detalhes/DadosAtoCard.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;CACjB;AACD;EACE,oBAAoB;CACrB","file":"DadosAtoCard.vue","sourcesContent":["\n.inline[data-v-242394c1] {\n  display: inline;\n}\n.toolbar4[data-v-242394c1] {\n  background: #2C397F;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-242394c1","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/detalhes/DadosAtoCard.vue
// module id = 4XuZ
// module chunks = 1